import { render, staticRenderFns } from "./RoundLoader.vue?vue&type=template&id=0e1a29b2&"
import script from "./RoundLoader.vue?vue&type=script&lang=ts&"
export * from "./RoundLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports